import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFlashcards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"flashcards, cards, pages"} maskId="square-filled-radius-0-stroke-1-IconFlashcards"><path d="M3 8.04528L12.9452 7L14.412 20.9553L4.46676 22.0005L3 8.04528Z" fill="currentColor"/><path d="M21.1123 3.04492L19.6455 17.001L14.9492 16.5068L13.835 5.90137L10.7227 6.22754L11.167 2L21.1123 3.04492Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFlashcards;
